export default "__VITE_ASSET__CzgHV5J___"